// extracted by mini-css-extract-plugin
export var accordionWrapper = "n_7";
export var addTransition = "n_8";
export var content = "n_9";